/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_CompanyInputs */

const en_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const zh_hans1_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公司`)
};

const pt_br2_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

const es_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

const fr_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const de_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

const ru_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания`)
};

const it_footer_company = /** @type {(inputs: Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azienda`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Footer_CompanyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_company = /** @type {((inputs?: Footer_CompanyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CompanyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_company(inputs)
	if (locale === "pt-BR") return pt_br2_footer_company(inputs)
	if (locale === "es") return es_footer_company(inputs)
	if (locale === "fr") return fr_footer_company(inputs)
	if (locale === "de") return de_footer_company(inputs)
	if (locale === "ru") return ru_footer_company(inputs)
	if (locale === "it") return it_footer_company(inputs)
	return en_footer_company(inputs)
});